module.exports = __webpack_public_path__ + "static/media/image.eca9f038.webp";